import Batch from "./Batch";

export default Batch;
